'use client'

import { useRef, createContext, useMemo } from 'react'

interface ArticleRefs {
	titleRef: React.RefObject<HTMLDivElement> | null
	bodyRef: React.RefObject<HTMLDivElement> | null
}

export const ArticleRefContext = createContext<ArticleRefs>({
	titleRef: null,
	bodyRef: null,
})

interface ArticleRefProviderProps {
	children: React.ReactNode
}

export const ArticleRefProvider = ({ children }: ArticleRefProviderProps) => {
	const titleRef = useRef<HTMLDivElement>(null)
	const bodyRef = useRef<HTMLDivElement>(null)

	const refs: ArticleRefs = useMemo(
		() => ({
			titleRef,
			bodyRef,
		}),
		[],
	)

	return <ArticleRefContext.Provider value={refs}>{children}</ArticleRefContext.Provider>
}
